export default __webpack_public_path__ + "static/media/keywords.c898158f.csv";